export const en = {
    about: 'More info'
};
